enum SkeletonType {
  FULL_WIDTH = 'FULL_WIDTH',
  IMAGE_PANEL = 'IMAGE_PANEL',
  BUTTON = 'BUTTON',
}

enum SkeletonClass {
  FULL_WIDTH = 'skeleton-full-width',
  IMAGE_PANEL = 'skeleton-image',
  BUTTON = 'skeleton-button',
}

export { SkeletonType, SkeletonClass };
